<template>
  <div class="template-container">
    <el-input
      v-model="search"
      size="small"
      :placeholder="$t('app.pleaseEnterKeywordSearch')"
      style="width: 300px; margin-right: 20px"
    >
      <el-button
        size="small"
        slot="append"
        icon="el-icon-search"
        @click="getList()"
      ></el-button>
    </el-input>
    <el-button
      size="small"
      type="primary"
      icon="el-icon-plus"
      @click="handleNew()"
      >{{ $t("app.new") }}</el-button
    >
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column align="left" :label="$t('app.operation')">
        <template slot-scope="scope">
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)">{{
            $t("app.edit")
          }}</el-button>
          <el-button
            size="small"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
            >{{ $t("app.delete") }}</el-button
          >
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        :label="$t('app.templateCode')"
        prop="code"
      >
      </el-table-column>
      <el-table-column
        align="center"
        :label="$t('app.templateName')"
        prop="name"
      >
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align: center; margin-top: 20px"
      background
      :total="total"
      :current-page.sync="currentPage"
      @size-change="handleSizeChange"
      @current-change="getList"
      :page-sizes="[10, 50, 200, 1000]"
      :page-size="size"
      layout="total, sizes, prev, pager, next"
    >
    </el-pagination>
    <el-dialog
      :title="$t('app.delete')"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>{{ $t("app.isDelete") + "(" + deleteItem + ")" }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="info" @click="dialogVisible = false">{{
          $t("app.cancel")
        }}</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          @click="deleteTemplate()"
          >{{ $t("app.confirm") }}</el-button
        >
      </span>
    </el-dialog>
    <template-modal
      ref="templateModal"
      @handleAdd="addUser"
      @handleEdit="updateTemplate"
    ></template-modal>
  </div>
</template>

<script>
import {
  getList,
  deleteTemplate,
} from "@/api/systemManagement/templateManagement";
import TemplateModal from "./modules/TemplateModal";
export default {
  components: {
    TemplateModal,
  },
  data() {
    return {
      loading: false,
      size: 10,
      currentPage: 1,
      total: 100,
      dialogVisible: false,
      deleteItem: "",
      deleteIndex: "",
      tableData: [],
      search: "",
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      getList({
        templateCode: this.search,
        templateName: "",
        PageIndex: this.currentPage,
        PageSize: this.size,
      }).then((res) => {
        this.total = res.data.Total;
        this.tableData = res.data.Items.map((item) => {
          return {
            code: item.TemplateCode,
            name: item.TemplateName,
            addressee: item.ToUser,
            cc: item.CCUser,
            bcc: item.BCCUser,
            theme: item.Subject,
            content: item.Content,
          };
        });
      });
    },
    updateTemplate(index, obj) {
      this.tableData.splice(index, 1, obj);
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    handleEdit(index, row) {
      this.$refs.templateModal.edit(index, row);
    },
    handleDelete(index, row) {
      this.dialogVisible = true;
      this.deleteItem = row.code;
      this.deleteIndex = index;
    },
    deleteTemplate() {
      this.loading = true;
      deleteTemplate({ TemplateCode: this.deleteItem })
        .then(() => {
          this.loading = false;
          this.dialogVisible = false;
          this.tableData.splice(this.deleteIndex, 1);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleNew() {
      this.$refs.templateModal.new();
    },
    addUser(obj) {
      this.tableData.push(obj);
    },
  },
};
</script>
<style lang="scss" scoped>
.template-container {
  background-color: #fff;
  padding: 15px;
  border: solid 1px #ccc;
}
</style>
